module.exports = __webpack_public_path__ + "static/media/logo.388fd47e.jpg";